//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Schemas Import
import { fullResourceQuestion } from "../../../schemas/common/resource/question/resource-question";

//* Axios Import
import { privateApi } from "../../../services/apis/configs/apiClient";

//* Zod Import
import { z } from "zod";


const recourseQuestionDetailResponseSchema = z.object({
  recurso: fullResourceQuestion,
});

/**
 * Resource Question API
 */
const ResourceQuestionAPI = {
  /**
   * Gets a specific resource by its ID
   * @param id Resource ID to be retrieved
   * @returns Complete resource details or error
   */
  getById: async function (id: string | undefined) {  
    try {
      const response = await privateApi.get(
        `/student_portal/private/recursos/questoes/${id}`
      );

      const validatedResponse = recourseQuestionDetailResponseSchema.parse(
        response.data
      );

      return {
        data: validatedResponse.recurso,
        success: true,
      };
        } catch (error) {
      console.error(`Error fetching resource with ID ${id}:`, error);
      return {
        data: null,
        success: false,
        message:
          "Could not load resource details. Please try again later.",
      };
    }
  },
};



/**
 * Hook to get a specific resource by ID
 * @param id Resource ID to be retrieved
 * @returns Query for complete resource details
 */
export function useGetResourceQuestionById(id: string | undefined) {
  return useQuery({
    queryKey: ["resource-question", id],
    queryFn: async () => await ResourceQuestionAPI.getById(id),
    retry: 2,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    enabled: !!id,
  });
}
